import classNames from "classnames";
import { AccentIcon, accentFor, formatStat } from "common/StatIcon";
import { inputStyles } from "common/form/InputField";
import { Loader } from "common/Loader";
import { Table } from "common/Table/Table";
import { useRouter } from "hooks/useRouter";
import { Fragment, useEffect, useState } from "react";
import UserService from "services/user.service";
import { exportToCSV, objectToQueryString } from "utils/funcs";
import { tabStyles } from "./GeneralData";
import { BlackSparrowLocation } from "components/blackSparrow/BlackSparrowLocation";

const service = new UserService();


export const TAGS = [
  "YESTERDAY",
  "TODAY",
  "WEEKTODATE",
  "LASTWEEK",
  "LASTMONTH",
  "MONTHTODATE",
  "YEARTODATE",
  "CUSTOM",
];

export const displayNames = {
  candidates: "Total Candidates",
  screening_approved: "Screening Approved",
  screening_declined: "Screening Declined",
  screening_completed: "Screening Completed",
  group_infosession: "Group Infosession Scheduled",
  group_infosession_raffle: "Group Infosession Attended",
  attende_offer: "Attendee Offer",
  attende_hire: "Attendee Hire",
  contract_sent: "Contract Sent",
  contract_signed: "Agreement Signed",
  last_street_genie_login: "Street Genie Login",
  completed_training: "Completed Training",
  last_credit_run_date: "Ran Credit",
  last_install_date: "Sales Install",
  onboarded_date: "Onboarded",
  upgrades: "Upgrades",
  register_for_blitz: "Registered for Blitz",
  attended_blitz: "Attended Blitz",
  goals_set: "Goals Set",
  signedReps: "Signed Reps",
};

export const BlackSparrow = () => {
  const { push, query } = useRouter();

  // {
  //   candidates: "Total Candidates",
  //   screening_approved: "Screening Completed",
  //   screening_declined: "Screening Approved",
  //   group_infosession: "Group Infosession Scheduled",
  //   group_infosession_raffle: "Group Infosession Attended",
  //   attende_offer: "Attendee Offer",
  //   attende_hire: "Attendee Hire",
  //   contract_sent: "Contract Sent",
  //   contract_signed: "Agreement Signed",
  //   last_street_genie_login: "Street Genie Login",
  //   completed_training: "Completed Training",
  //   last_credit_run_date: "Ran Credit",
  //   last_install_date: "Sales Install",
  //   onboarded_date: "Onboarded",
  //   upgrades: "Upgrades",
  //   register_for_blitz: "Registered for Blitz",
  //   attended_blitz: "Attended Blitz",
  //   goals_set: "Goals Set"
  // };

  const columns = [
    { key: "manager_id", dbColName: "manager_id", title: "manager id", 
       freeze: true,
      freezeIndex: "left-0"
     },
    { key: "manager_name", dbColName: "manager_name", title: "manager name",
      freeze: true,
      freezeIndex: "left-24"
     },
    // {key: "candidates",dbColName: "candidates", title: "candidates"},
    // {key: "screening_completed",dbColName: "screening_completed", title: "screening_completed"},
    // {key: "screening_approved",dbColName: "screening_approved", title: "screening_approved"},
    {
      key: "group_infosession",
      dbColName: "group_infosession",
      title: "Group Infosession Scheduled",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "group_infosession_raffle",
      dbColName: "group_infosession_raffle",
      title: "Group Infosession Attended",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "attende_offer",
      dbColName: "attende_offer",
      title: "Attendee Offer",
      render: row => <p className="text-center">{row}</p>
    },
    { key: "attende_hire", dbColName: "attende_hire", title: "attendee hire",
      render: row => <p className="text-center">{row}</p>
     },
    { key: "signedReps", dbColName: "signedReps", title: "signedReps",
      render: row => <p className="text-center">{row}</p>
     },
    {
      key: "contract_sent",
      dbColName: "contract_sent",
      title: "contract sent",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "contract_signed",
      dbColName: "contract_signed",
      title: "contract signed",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "last_street_genie_login",
      dbColName: "last_street_genie_login",
      title: "street Genie Login",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "completed_training",
      dbColName: "completed_training",
      title: "completed training",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "last_credit_run_date",
      dbColName: "last_credit_run_date",
      title: "ran credit",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "last_install_date",
      dbColName: "last_install_date",
      title: "sales install",
      render: row => <p className="text-center">{row}</p>
    },
    { key: "onboarded_date", dbColName: "onboarded_date", title: "onboarded",
      render: row => <p className="text-center">{row}</p>
     },
    { key: "upgrades", dbColName: "upgrades", title: "upgrades" },
    {
      key: "register_for_blitz",
      dbColName: "register_for_blitz",
      title: "registered for blitz",
      render: row => <p className="text-center">{row}</p>
    },
    {
      key: "attended_blitz",
      dbColName: "attended_blitz",
      title: "attended blitz",
      render: row => <p className="text-center">{row}</p>
    },
    { key: "goals_set", dbColName: "goals_set", title: "goals set",
      render: row => <p className="text-center">{row}</p>
     },
    // {
    //   key: "action",
    //   freeze: true,
    //   freezeIndex: "right-0",
    //   title: "action",
    //   render: (row) => {
    //     return (
    //       <button
    //         type="button"
    //         onClick={() =>
    //           push(
    //             `/sparrow-report/${row.manager_id}?manager=${row.manager_name}`
    //           )
    //         }
    //         className="text-blue-500"
    //       >
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           fill="none"
    //           viewBox="0 0 24 24"
    //           strokeWidth={1.5}
    //           stroke="currentColor"
    //           className="h-6 w-6"
    //         >
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    //           />
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    //           />
    //         </svg>
    //       </button>
    //     );
    //   },
    // },
  ];

  const [categories, setCategories] = useState<any>([]);
  const [statesFilter, setStatesFilter] = useState({
    flag: "YES",
    date: "LASTWEEK",
    type: "info",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});


  useEffect(() => {
    setLoading(true);
    service
      .getBlackSparrow(statesFilter)
      .then((resp) => {
        setCategories(resp.data.total_docs);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [statesFilter]);

  const [filter, setFilter] = useState({
    type: "info",
    date: "LASTWEEK",
    flag: "YES",
  });
  const [loadingStats, setLoadingStats] = useState(false);

  useEffect(() => {
    setLoadingStats(true);
    service
      .getBlackSparrowStats(filter)
      .then((stats) => {
        delete stats.data.total_docs.onboarded_date;
        // delete stats.data.total_docs.last_install_date
        setData(stats.data.total_docs);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoadingStats(false);
      });
  }, [filter]);

 

  const filteredData = Object.entries(data).filter(
    ([key]) => key !== "signedReps"
  );

  const handleExport = () => {
    exportToCSV(categories, "categories");
  };

  return (
    <Fragment>
      <div className="flex justify-between items-center mb-4">
        <div className="flex  gap-2">
          <button
            type="button"
            onClick={() => push("/weekly-trainings")}
            className="btn-secondary p-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
              />
            </svg>
          </button>
          <div>
            <h1 className="page-title">
              Black Sparrow
            </h1>
            <p className="page-subtitle">
              View all back sparrow report
            </p>
          </div>
        </div>
        {query.tab === "Reports" && (
          <div className=" flex items-center gap-3">
            <select
              className={inputStyles.input}
              value={filter.date}
              onChange={(e) => setFilter({ ...filter, date: e.target.value })}
            >
              {TAGS.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
            <select
              className={inputStyles.input}
              value={filter.type}
              onChange={(e) => setFilter({ ...filter, type: e.target.value })}
            >
              <option value="info">Group Interview</option>
              <option value="Black">All</option>
            </select>
            <select
              className={inputStyles.input}
              value={filter.flag}
              onChange={(e) => setFilter({ ...filter, flag: e.target.value })}
            >
              {/* <option value="">Select</option> */}
              <option value="NO">Master Date</option>
              <option value="YES">Cohort Date</option>
              {/* <option value="NO">No</option> */}
            </select>
          </div>
        )}
      </div>

      <div className="tabs mb-4">
        <div className="flex flex-wrap gap-1">
          <button
            type="button"
            onClick={() => push("/black-sparrow?tab=Reports")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: query.tab === "Reports",
            })}
          >
            Reports
          </button>
          <button
            type="button"
            onClick={() => push("/black-sparrow")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: !query.tab,
            })}
          >
            Reporting By Manager
          </button>
          <button
            type="button"
            onClick={() => push("/black-sparrow?tab=Location")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: query.tab === "Location",
            })}
          >
            Reporting By Location
          </button>
        </div>
      </div>

      <div className={` ${query.tab === "Reports" ? "block" : "hidden"} `}>
        {loadingStats ? (
          <Loader />
        ) : (
          <div className="w-full">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
              {filteredData.map(([key, value]) => (
                <div
                  key={key}
                  className="cursor-pointer"
                  onClick={() =>
                   {
                    if(displayNames[key] === "Total Candidates" || displayNames[key] === "Screening Approved" || displayNames[key] === "Screening Completed") {
                      return 
                    } else {
                      push(`/sparrow-users?${objectToQueryString({...filter, tab: key })}`)
                    }
                   }
                  }
                >
                  <MetricCard
                    label={key}
                    displayName={displayNames[key] || key}
                    value={value}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className={` ${!query.tab ? "block" : "hidden"} `}>
        <Table
          data={categories}
          loadingData={loading}
          handleExport={handleExport}
          totalItems={categories.length}
          filters={
            <div className="flex gap-2">
              <select
                className="w-60 px-3 py-2 text-sm"
                value={statesFilter.date}
                onChange={(e) =>
                  setStatesFilter({ ...statesFilter, date: e.target.value })
                }
              >
                {TAGS.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {/* <select
                className="w-60 px-3 py-2 text-sm"
                value={statesFilter.type}
                onChange={(e) =>
                  setStatesFilter({ ...statesFilter, type: e.target.value })
                }
              >
                <option value="info">Group Interview</option>
                <option value="Black">All</option>
              </select> */}
              <select
                className="w-60 px-3 py-2 text-sm"
                value={statesFilter.flag}
                onChange={(e) =>
                  setStatesFilter({ ...statesFilter, flag: e.target.value })
                }
              >
                {/* <option value="">Select</option> */}
                <option value="NO">Master Date</option>
                <option value="YES">Cohort Date</option>
                {/* <option value="NO">No</option> */}
              </select>
            </div>
          }
          columns={columns}
        />
      </div>
      <div className={` ${query.tab === "Location" ? "block" : "hidden"} `}>
        <BlackSparrowLocation />
      </div>
    </Fragment>
  );
};

export const MetricCard = ({ label, className, displayName, value, accent, icon }: any) => {
  // Pages mark clickable cards with an "underline" class; show an arrow instead.
  const isLink = typeof className === "string" && className.includes("underline");
  const tone = accent ?? accentFor(displayName ?? label);
  return (
    <Card
      className={classNames("p-4 flex items-center gap-3 min-w-0", {
        "hover:border-line-strong hover:shadow-card-md transition-all duration-150 group": isLink,
      })}
    >
      <AccentIcon name={icon ?? "chart"} accent={tone} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <p className="stat-label">{displayName}</p>
          {isLink && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.75}
              stroke="currentColor"
              className="w-3.5 h-3.5 text-ink-muted group-hover:text-ink shrink-0 transition-colors"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          )}
        </div>
        <p className="stat-value leading-tight">{formatStat(value)}</p>
      </div>
    </Card>
  );
};

export const Card = ({ className, children, color }: any) => {
  return <div className={classNames("card", color, className)}>{children}</div>;
};
